<template>
<div id="main" class="column is-9">
		<Spinner size="huge" v-if="!idle"></Spinner>
			<section class="profile" v-if="idle">
			<div class="columns">
				<div class="column">
					<div class="card">
						<header class="card-header">
						<p class="card-header-title">
							My Profile
						</p>
						</header>
						<div class="card-table">
							<div class="content">
								<div class="columns">
									<div class="column">
										<form>
											<h3>Password</h3>
											<div class="field is-maxed">
												<a class="button is-primary is-small" @click="passwordOpen = true">></a>
											</div>
											<h3>Contact Information</h3>
											<label class="label">First Name</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" disabled
													@change="checkFirst" :class="{'is-danger': errors.first}"
													:value="profile.first"
												type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-user"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.first">
													{{ errors.first }}
												</p>
											<label class="label">Last Name</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" disabled
													@change="checkLast" :class="{'is-danger': errors.last}"
													:value="profile.last"
												type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-user"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.last">
													{{ errors.last }}
												</p>
											<label class="label">Address 1</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" disabled
													@change="checkAddress1" :class="{'is-danger': errors.address1}" 
													:value="profile.address1"
													type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.address1">
													{{ errors.address1 }}
												</p>
											<label class="label">Address 2</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" disabled
													@change="checkAddress2" :class="{'is-danger': errors.address2}" 
													:value="profile.address2"
													type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.address2">
													{{ errors.address2 }}
												</p>
											<label class="label">Country</label>
											<div class="field is-maxed">
												<p class="control has-icons-left">
												<span class="select is-small">
												<select @change="checkCountry" disabled :class="{'is-danger': errors.country}" :value="profile.country">
													<option selected="select is-smalled" value="">Select Country</option>
													<option v-for="country in countries" :key="country.country_code" :value="country.country_code">{{ country.country_name }}</option>
												</select>
												</span>
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</p>
											</div>
												<p class="help is-danger" v-if="errors.country">
													{{ errors.country }}
												</p>
											<label class="label">Zip/Postal Code</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" disabled
													@change="checkPostalCode" :class="{'is-danger': errors.postal_code}" 
													:value="profile.postal_code"
												type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.postal_code">
													{{ errors.postal_code }}
												</p>
											<label class="label">City</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" disabled
													@change="checkCity" :class="{'is-danger': errors.city}" 
													:value="profile.city"
												type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.city">
													{{ errors.city }}
												</p>
											<label class="label">{{ regionLabel }}</label>
											<div class="field is-maxed">
												<p class="control has-icons-left">
												<span class="is-small is-expanded" :class="{'select is-expanded': regionDomestic, 'input': !regionDomestic}">
												<select disabled :value="profile.region" v-if="regionDomestic">
													<option selected="select is-smalled" value="">Select State/Prov.</option>
													<option v-for="state in stateList" :key="state.state_abbr" :value="state.state_abbr">{{state.state_name}}</option>
												</select>
												<input class="input is-small" disabled
													@change="checkRegion" :class="{'is-danger': errors.region}" 
													:value="profile.region"
													v-if="!regionDomestic"
												type="text" placeholder="">
												</span>
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</p>
											</div>
												<p class="help is-danger" v-if="errors.region">
													{{ errors.region }}
												</p>
											
											<label class="label">Email</label>
											<div class="field has-addons is-maxed">
												<div class="control has-icons-left has-icons-right is-expanded">
												<input class="input is-small" type="email" 
													@change="checkEmail" :class="{'is-danger': errors.email}" 
													v-model.trim="profile.email"
												placeholder="" value="">
												<span class="icon is-small is-left">
												<i class="fa fa-envelope"></i>
												</span>
												<span class="icon is-small is-right">
												<i class="fa fa-exclamation-triangle"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.email">
													{{ errors.email }}
												</p>
											<label class="label">Phone Numbers</label>
											<div class="field is-maxed">
												<a class="button is-primary is-small" @click="phonesOpen = true">></a>
											</div>	
											<div class="field is-maxed">
												<label class="label">Preferred Contact Method</label>
												<div class="control">
													<label class="radio">
													<input type="radio" v-model="profile.contact_method" value="E">
													Email </label>
													<label class="radio">
													<input type="radio" v-model="profile.contact_method" value="P">
													Phone </label>
												</div>
											</div>
											<h3>Other Information</h3>
											<label class="label">PIN</label>
											<div class="field is-maxed">
												<div class="control has-icons-left has-icons-right">
												<input class="input is-small" 
													@change="checkPin" :class="{'is-danger': errors.pin}" 
													v-model.trim="profile.pin"
													type="text" placeholder="1234">
												<span class="icon is-small is-left">
												<i class="fa fa-globe"></i>
												</span>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.pin">
													{{ errors.pin }}
												</p>
											<label class="label">Zodiac Sign</label>
											<div class="field is-grouped is-maxed">
												<div class="control is-expanded has-icons-left">
												<div class="select is-small is-fullwidth">
													<select
													@change="checkZodiac" :class="{'is-danger': errors.zodiac}" 
													v-model="profile.zodiac">
													<option value="">Select Zodiac Sign</option>
													<option value="1">Aries</option>
													<option value="2">Taurus</option>
													<option value="3">Gemini</option>
													<option value="4">Cancer</option>
													<option value="5">Leo</option>
													<option value="6">Virgo</option>
													<option value="7">Libra</option>
													<option value="8">Scorpio</option>
													<option value="9">Sagittarius</option>
													<option value="10">Capricorn</option>
													<option value="11">Aquarius</option>
													<option value="12">Pisces</option>
													</select>
													<span class="icon is-small is-left">
													<i class="fa fa-sun-o"></i>
													</span>
												</div>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.zodiac">
													{{ errors.zodiac }}
												</p>
											<label class="label">Gender </label>
											<div class="field is-grouped is-maxed">
												<div class="control">
													<label class="radio">
													<input type="radio" v-model="profile.gender" value="M">
													Male </label>
													<label class="radio">
													<input type="radio" v-model="profile.gender" value="F">
													Female </label>
												</div>
											</div>
											<label class="label">Primary Language</label>
											<div class="field is-grouped is-maxed">
												<div class="control is-expanded has-icons-left">
													<div class="select is-small is-fullwidth">
														<select v-model="profile.language" >
															<option v-for="language in languages()" :key="language.id" :value="language.id">{{language.name}}</option>
														</select>
													</div>
													<span class="icon is-small is-left">
													<i class="fa fa-sun-o"></i>
													</span>
												</div>
											</div>
											<label class="label">Other languages you are fluent in</label>
											<div class="field is-maxed">
												<div class="control">
													<label class="label">
														<a class="button is-small is-primary" @click="languagesOpen = true"><i class="fa fa-plus"></i></a>
														<span style="font-weight:normnal;margin-left:15px;line-height:40px" v-for="(id, idx) in profile.languages" :key="idx">
															{{language_text(id)}}
														</span>
													</label>
												</div>
											</div>
											<h3 class="is-maxed">Years Experience</h3>
											<div class="field has-addons is-maxed">
												<div class="control has-icons-left has-addons has-icons-right is-expanded">
												<input class="input is-small" 
													@change="checkExperience" :class="{'is-danger': errors.experience}" disabled
													:value="profile.experience"
												maxlength="2" type="text" placeholder="">
												<span class="icon is-small is-left">
												<i class="fa fa-calendar"></i>
												</span>
												</div>
												<div class="control">
												<button type="button" class="button is-small is-info has-tooltip-multiline has-tooltip-left" data-tooltip="2 digits, no letters or special characters."><i class="fa fa-info"></i></button>
												</div>
											</div>
												<p class="help is-danger" v-if="errors.experience">
													{{ errors.experience }}
												</p>
											<h3 class="is-maxed">Credentials</h3>
											<label><span class="is-maxed">We recommend listing credentials. This can help your listing. Please have documentation to support any of your credentials. Credentials can include educational degrees, psychic membership organizations, affiliations and employment.</span></label>
											<div class="field has-addons is-maxed" v-for="(cred, idx) in profile.credentials" :key="idx">
												<div class="control has-icons-left has-icons-right is-expanded">
												<input class="input is-small " type="text" v-model.trim="profile.credentials[idx]">
												<span class="icon is-small is-left">
												<i class="fa fa-star"></i>
												</span>
												</div>
												<div class="control">
												<a class="button is-small is-danger" @click="removeCredential(idx)"><i class="fa fa-remove"></i></a>
												</div>
											</div>
											<div class="field is-maxed" v-if="profile.credentials.length < 6">
												<div class="control">
												<a class="button is-small is-primary" @click="addCredential"><i class="fa fa-plus"></i></a>
												</div>
											</div>
											<p class="form-emphasis">
												Changes to credentials require manager approval. Profile is currently: {{ profile.profile_status }}
											</p>
											<div class="field is-grouped is-maxed">
												<div class="control">
													<button class="button is-small is-link" @click.prevent="save()">Submit</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			</section>
			<Modal v-if="languagesOpen" @close="languagesOpen = false">
				<span slot="title">Select Additional Languages</span>
				<div slot="body">
					<div class="field is-grouped is-maxed">
						<div class="control">
							<label class="checkbox">English <input type="checkbox" @click="selectAddLang" value="1" :checked="hasLang(1)">
							</label>
						</div>
						<div class="control">
							<label class="checkbox">Spanish <input type="checkbox" @click="selectAddLang" value="2" :checked="hasLang(2)">
							</label>
						</div>
					</div>
					<div class="field is-grouped is-maxed">
						<div class="control">
							<label class="checkbox">French <input type="checkbox" @click="selectAddLang" value="3" :checked="hasLang(3)">
							</label>
						</div>
						<div class="control">
							<label class="checkbox">German <input type="checkbox" @click="selectAddLang" value="5" :checked="hasLang(5)">
							</label>
						</div>
					</div>
					<div class="field is-grouped is-maxed">
						<div class="control">
							<label class="checkbox">Italian <input type="checkbox" @click="selectAddLang" value="6" :checked="hasLang(6)">
							</label>
						</div>
						<div class="control">
							<label class="checkbox">Russian <input type="checkbox" @click="selectAddLang" value="7" :checked="hasLang(7)">
							</label>
						</div>
					</div>
					<div class="field is-grouped is-maxed">
						<div class="control">
							<label class="checkbox">Slovak <input type="checkbox" @click="selectAddLang" value="8" :checked="hasLang(8)">
							</label>
						</div>
					</div>
				</div>
				<div class="field is-grouped" slot="footer">
					<div class="control">
						<a class="button is-small is-light" @click="languagesOpen = false">Close</a>
					</div>
				</div>
			</Modal>
			<PhonesModal v-if="phonesOpen" :phones="profile.phones" :id="user_id" @close="phonesOpen = false" :readonly="true" />
			<PasswordModal v-if="passwordOpen" @close="passwordOpen = false" />
		</div>
</template>

<script>
	import countries from "../../countries.js"
	import states from "../../states.js"
	import Modal from "../Modal.vue"
	import PhonesModal from "../shared/PhonesModal.vue"
	import PasswordModal from "../shared/ChangePasswordModal.vue"
	import Spinner from 'vue-simple-spinner'
	

	export default {
		components: {
			Modal,
			PhonesModal,
			PasswordModal,
			Spinner
		},
		data() {
			return {
				passwordOpen: false,
				countries: countries,
				states: states,
				user_id: null,
				languagesOpen: false,
				phonesOpen: false,
				errors: {
					pin: null,
					username: null,
					first: null,
					last: null,
					address1: null,
					address2: null,
					postal_code: null,
					city: null,
					region: null,
					country: null,
					email: null,
					phone: null,
					zodiac: null,
					language: null,
					experience: null,
					credentials: null,
				},
				profile: {
					profile_status: "",
					pin: "",
					first: "",
					last: "",
					address1: "",
					address2: "",
					postal_code: "",
					phone_type: 1,
					city: "",
					region: "",
					country: "",
					email: "",
					phones: [],
					country_code: 1,
					contact_method: "P",
					zodiac: "",
					gender: "F",
					language: 1,
					languages: [],
					experience: "",
					credentials: [""],
				},
				idle: false
			}
		},
		methods: {
			languages() {
				return [
					{ id: 1, name: "English" },
					{ id: 2, name: "Spanish"},
					{ id: 3, name: "French"},
					{ id: 5, name: "German"},
					{ id: 6, name: "Italian"},
					{ id: 7, name: "Russian"},
					{ id: 8, name: "Slovak"}
				]
			},
			language_text(id) {
				const languages = this.languages()
				for (const idx in languages) {
					if (languages[idx].id === id) {
						return languages[idx].name
					}
				}
			},
			selectAddLang(e) {
				let exists = false
				let newLangs = []
				for (let i = 0; i < this.profile.languages.length; i++) {
					if (this.profile.languages[i] === parseInt(e.target.value)) {
						exists = true
					} else {
						newLangs.push(this.profile.languages[i])
					}
				}

				if (e.target.checked) {
					if (!exists) {
						this.profile.languages.push(parseInt(e.target.value))
					}
				} else {
					if (exists) {
						this.profile.languages = newLangs
					}
				}
			},
			hasLang(id) {
				for (let i = 0; i < this.profile.languages.length; i++) {
					if (id === this.profile.languages[i] ) {
						return true
					}
				}
				return false
			},
			async checkPin() {
				this.errors.pin = null
				if (this.profile.pin === "") {
					this.errors.pin = "Pin is required"
				} else if (!/^\d{4}$/.test(this.profile.pin)) {
					this.errors.pin = "Pin is invalid, must be 4 numbers."
				}

				/*if (this.psychic.phone !== "" && this.psychic.pin !== "" &&
				this.errors.pin === null && this.errors.phone === null) {
					if (!(await this.$root.$data.getters.phonePinAvailable(this.$root.$data.state, this.psychic.phone, this.psychic.pin))) {
						this.errors.username = "Phone/Pin combo is taken"
					}
				}*/

				return this.errors.pin === null
			},
			checkFirst() {
				this.errors.first = null
				if (this.profile.first === "") {
					this.errors.first = "First Name is required"
				} else if (this.profile.first.length > 50) {
					this.errors.first = "First Name is invalid"
				}

				return this.errors.first === null
			},
			checkLast() {
				this.errors.last = null
				if (this.profile.last == "") {
					this.errors.last = "Last Name is required"
				} else if (this.profile.last.length > 50) {
					this.errors.last = "Last Name is invalid"
				}

				return this.errors.last === null
			},
			checkAddress1() {
				this.errors.address1 = null
				if (this.profile.address1 == "") {
					this.errors.address1 = "Address1 is required"
				} else if (this.profile.address1.length > 99) {
					this.errors.address1 = "Address1 is invalid"
				}

				return this.errors.address1 === null
			},
			checkAddress2() {
				this.errors.address2 = null
				if (this.profile.address2.length > 99) {
					this.errors.address2 = "Address2 is invalid"
				}

				return this.errors.address2 === null
			},
			checkPostalCode() {
				this.errors.postal_code = null

				if(this.profile.postal_code === "") {
					this.errors.postal_code = "Zip/Postal Code is required"
				} else if (/^\d{5}$/.test(this.profile.postal_code) && this.profile.country === "US") {
					this.$root.$data.getters.getCityState(this.$root.$data.state, this.profile.postal_code).then((cs) => {
						if (cs.length > 0) {
							this.profile.city = cs[0].city
							this.profile.region = cs[0].state
						}
					})
				} else {
					this.errors.postal_code = "Zip/Postal Code is invalid"
				}

				return this.errors.postal_code === null
			},
			checkCity() {
				this.errors.city = null
				if (this.profile.city === "") {
					this.errors.city = "City is required"
				} else if (this.profile.city.length > 99) {
					this.errors.city = "City is invalid"
				}

				return this.errors.city === null
			},
			checkRegion() {
				this.errors.region = null
				if (this.profile.region === "") {
					this.errors.region = "State/Region is required"
				} else if (this.profile.region.length > 99) {
					this.errors.region = "State/Region is invalid"
				}

				return this.errors.region === null
			},
			checkCountry() {
				this.errors.country = null

				if (this.profile.country != "") {
					this.profile.country_code = parseInt(this.countries.filter((c) => c.country_code === this.profile.country)[0].intl_prefix.trim())
				} else{
					this.profile.country_code = 1
					this.errors.country = "Country required"
				}

				return this.errors.country === null
			},
			checkEmail() {
				this.errors.email = null
				if (this.profile.email === "") {
					this.errors.email = "Email is required"
				} if (this.profile.email.length > 99) {
					this.errors.email =- "Email is not valid"
				}

				return this.errors.email === null
			},
			checkZodiac() {
				this.errors.zodiac = null
				if (this.profile.zodiac === "") {
					this.errors.zodiac = "Zodiac Sign is required"
				}

				return this.errors.zodiac === null
			},
			checkExperience() {
				this.errors.experience = null
				if (this.profile.experience === "") {
					this.errors.experience = "Years Experience is required"
				} else if (!/^\d{1,2}$/.test(this.profile.experience)) {
					this.errors.experience = "Years Experience is invalid. Must be numeric."
				}

				return this.errors.experience === null
			},
			addCredential() {
				this.profile.credentials.push("")
			},
			removeCredential(idx) {
				let newCreds = []
				for(let i = 0; i < this.profile.credentials.length; i++) {
					if (i === idx) {
						continue
					} else {
						newCreds.push(this.profile.credentials[i])
					}
				}
				this.profile.credentials = newCreds
			},
			async valid() {
				let valid = true
				valid = await this.checkPin() && valid
				valid = this.checkFirst() && valid
				valid = this.checkLast() && valid
				valid = this.checkAddress1() && valid
				valid = this.checkAddress2() && valid
				valid = this.checkCountry() && valid
				valid = this.checkPostalCode() && valid
				valid = this.checkCity() && valid
				valid = this.checkRegion() && valid
				valid = this.checkEmail() && valid
				valid = this.checkZodiac() && valid
				valid = this.checkExperience() && valid

				return valid
			},
			async save() {
				if (this.profile.address2 === null) {
					this.profile.address2 = ""
				}
				
				if (await this.valid()) {
				try {
					await this.$root.$data.setters.updateProfile(this.$root.$data.state, this.profile)
					this.$notify({
						group: 'global',
						type: 'success',
						title: 'Profile Updated',
						text: 'Your profile was updated',
					})
					this.$router.push("/psychic")
				} catch{ return; }
				}
			}
		},
		computed: {
			stateList() {
				if (this.profile.country !== "") {
					return this.states.filter((s) => s.country_abbr == this.profile.country)
				}
				return []
			},
			regionDomestic() {
				return ["", "US", "CA"].includes(this.profile.country)
			},
			regionLabel() {
				if (["", "US", "CA"].includes(this.profile.country)) {
					return "State/Prov"
				}
				return "Region"
			},
		},
		async created() {
			this.user_id = JSON.parse(localStorage.getItem("user")).user_id
			this.profile = await this.$root.$data.getters.getProfile(this.$root.$data.state, this.user_id)
			this.idle = true
		}
	}
</script>